import {Link} from "react-router-dom";

interface SidebarProps {
    id?: string
    hideMenu?: () => void
    // phone menu only: the page you're on, so the menu can leave it out
    current?: string
}

const PAGES = ["projects", "photos", "friends"];

export function Sidebar({id, hideMenu, current}: SidebarProps) {
    // The desktop sidebar always has all three. The phone menu leaves out the page
    // you're on, and projects on the about page (which has its own button for it).
    const pages = id === "mainScreen"
        ? PAGES
        : PAGES.filter(p => p !== current && !(p === "projects" && current === "about"));
    return (
        <div className={"side"} id={id}>
            {pages.map(p => <Link key={p} className={"button"} to={`/${p}`} onClick={hideMenu}>{p}</Link>)}
        </div>
    );
}
